function parseSizeValue(value) {
    const waistInseam = /^(\d{2})\/(\d{2})$/.exec(value);
    const numeric = /^\d+$/.exec(value);
    const letter = /^(XXXS|XXS|XS|S|M|L|XL|XXL|XXXL)$/.exec(value);
    const lower = value.toLowerCase();
  
    return {
      value,
      isOneSize: /^(one ?size|onesi)$/i.test(value),
      isNamedSize: ['small', 'medium', 'large'].includes(lower),
      namedSizeIndex: ['small', 'medium', 'large'].indexOf(lower),
      isLetter: !!letter,
      isNumeric: !!numeric,
      isWaistInseam: !!waistInseam,
      waist: waistInseam ? parseInt(waistInseam[1], 10) : null,
      inseam: waistInseam ? parseInt(waistInseam[2], 10) : null,
      numericValue: numeric ? parseInt(value, 10) : null,
      letterIndex: letter ? ['XXXS', 'XXS', 'XS', 'S', 'M', 'L', 'XL', 'XXL', 'XXXL'].indexOf(letter[0]) : null,
    };
  }
  
  export const sortSizes = (data) => {
    return [...data].sort((a, b) => {
      const aVal = parseSizeValue(a.value);
      const bVal = parseSizeValue(b.value);
  
      // 1. OneSize first
      if (aVal.isOneSize && !bVal.isOneSize) return -1;
      if (!aVal.isOneSize && bVal.isOneSize) return 1;
  
      // 2. Named sizes (Small, Medium, Large)
      if (aVal.isNamedSize && bVal.isNamedSize) {
        return aVal.namedSizeIndex - bVal.namedSizeIndex;
      }
      if (aVal.isNamedSize && !bVal.isNamedSize) return -1;
      if (!aVal.isNamedSize && bVal.isNamedSize) return 1;
  
      // 3. Letter sizes
      if (aVal.isLetter && bVal.isLetter) {
        return aVal.letterIndex - bVal.letterIndex;
      }
  
      // 4. Waist/inseam
      if (aVal.isWaistInseam && bVal.isWaistInseam) {
        return aVal.waist === bVal.waist
          ? aVal.inseam - bVal.inseam
          : aVal.waist - bVal.waist;
      }
  
      // 5. Pure numeric
      if (aVal.isNumeric && bVal.isNumeric) {
        return aVal.numericValue - bVal.numericValue;
      }
  
      // 6. Grouping priority fallback
      const priority = (p) =>
        p.isLetter ? 0 : p.isWaistInseam ? 1 : p.isNumeric ? 2 : 3;
  
      return priority(aVal) - priority(bVal);
    });
  };
  